// Chopped and screwed from https://github.com/arhs/iban.js

const IBANRegex = new RegExp("^RO[0-9]{2}[A-Z]{4}[A-Z0-9]{16}$", "i");

const A = "A".charCodeAt(0),
  Z = "Z".charCodeAt(0);

// Prepare an IBAN for mod 97 computation by moving the first 4 chars to the end and transforming the letters to
// numbers (A = 10, B = 11, ..., Z = 35), as specified in ISO13616.
const iso13616Prepare = (iban) => {
  iban = iban.toUpperCase();
  iban = iban.substr(4) + iban.substr(0, 4);

  return iban
    .split("")
    .map((n) => {
      const code = n.charCodeAt(0);

      if (code >= A && code <= Z) {
        // A = 10, B = 11, ... Z = 35
        return code - A + 10;
      } else {
        return n;
      }
    })
    .join("");
};

// Calculates the MOD 97 10 of the passed IBAN as specified in ISO7064.
const iso7064Mod97_10 = (iban) => {
  let remainder = iban,
    block;

  while (remainder.length > 2) {
    block = remainder.slice(0, 9);
    remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length);
  }

  return parseInt(remainder, 10) % 97;
};

const isValid = (iban) =>
  typeof iban === "string" &&
  iban.length === 24 &&
  IBANRegex.test(iban) &&
  iso7064Mod97_10(iso13616Prepare(iban)) === 1;

export default isValid;
